import React from 'react';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';
import dateTimeHelper from '../Helpers/datetimeHelper';
import stringHelper from '../Helpers/stringHelper';
import LongText from '../Elements/LongText';

export default class FinalizedAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = '';
      this.AsSassieAsgnId = '';
      this.CuName = '';
      this.AsFee = '';
      this.OpportunityCurrencySymbol = '';
      this.AsFeeAddit = '';
      this.AsReimbursement = '';
      this.ReimbursementCurrencySymbol = '';
      this.AsTravel = '';
      this.AsGaming = '';
      this.AsMisc = '';
      this.AsLdvname = '';
      this.AsFieldworkFee = '';
      this.AsEvname = '';
      this.LgsDesc = '';
      this.AsEvaluatorCompletedDate = '';
      this.CuCountry = '';
      this.AsFeeWithSymbol = '';
      this.AsEvaluatorCompletedDateFormatted = '';
      this.AsFeeAdditWithSymbol = '';
      this.AsReimbursementWithSymbol = '';
      this.AsTravelWithSymbol = '';
      this.AsGamingWithSymbol = '';
      this.AsMiscWithSymbol = '';
      this.AsFieldworkFeeWithSymbol = '';
      this.AsCfname = '';
      this.AsCfid = '';
      this.AsSassieSurveyId = '';
      this.SurveyName = '';
      this.FeeTotal = '';
      this.ReimbTotal = '';
      this.Selected = false;
      return;
    }
    this.AsId = item.asId;
    this.AsSassieAsgnId = item.asSassieAsgnId;
    this.CuName = item.cuName;
    this.AsFee = item.asFee;
    this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
    this.AsFeeAddit = item.asFeeAddit;
    this.AsReimbursement = item.asReimbursement;
    this.ReimbursementCurrencySymbol = item.reimbursementCurrencySymbol;
    this.AsTravel = item.asTravel;
    this.AsGaming = item.asGaming;
    this.AsMisc = item.asMisc;
    this.AsLdvname = item.asLdvname;
    this.AsFieldworkFee = item.asFieldworkFee;
    this.AsEvname = item.asEvname;
    this.LgsDesc = item.lgsDesc;
    this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
    this.CuCountry = item.cuCountry;
    this.AsFeeWithSymbol = stringHelper.getValueWithSymbol('', item.opportunityCurrencySymbol, item.asFee);
    this.AsEvaluatorCompletedDateFormatted = dateTimeHelper.toYYYYsMMsDD(item.asEvaluatorCompletedDate, '-');
    this.AsFeeAdditWithSymbol = stringHelper.getValueWithSymbol('', item.reimbursementCurrencySymbol, item.asFeeAddit);
    this.AsReimbursementWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.opportunityCurrencySymbol,
      item.asReimbursement
    );
    this.AsTravelWithSymbol = stringHelper.getValueWithSymbol('', item.opportunityCurrencySymbol, item.asTravel);
    this.AsGamingWithSymbol = stringHelper.getValueWithSymbol('', item.opportunityCurrencySymbol, item.asGaming);
    this.AsMiscWithSymbol = stringHelper.getValueWithSymbol('', item.opportunityCurrencySymbol, item.asMisc);
    this.AsFieldworkFeeWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.opportunityCurrencySymbol,
      item.asFieldworkFee
    );
    this.AsCfname = item.asCfname;
    this.AsCfid = item.asCfid;
    this.AsSassieSurveyId = item.asSassieSurveyId;
    this.SurveyName = item.surveyName;
    this.FeeTotal = stringHelper.getFeeTotal('$', [item.asFee, item.asFeeAddit]);
    this.ReimbTotal = stringHelper.getFeeTotal(item.opportunityCurrencySymbol, [
      item.asReimbursement,
      item.asTravel,
      item.asGaming,
      item.asMisc,
    ]);
    this.Selected = false;
    this.EvalFeeTotal = stringHelper.getValueWithSymbol('', item.evaluatorCurrencySymbol, item.evalFeeTotal);
    this.EvalReimbursementTotal = stringHelper.getValueWithSymbol(
      '',
      item.reimbursementCurrencySymbol,
      item.evalReimbTotal
    );
  }

  static NameOfTheIdField() {
    return 'AsId';
  }
  static nameOfTheItemDetailList() {
    return 'Ready for Invoicing';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='assignments'
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: 'AsBillClient', value: '' },
          { key: 'AsPayEvaluator', value: '' },
          { key: 'AsSassieAsgnId', value: item.AsSassieAsgnId },
        ]}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: FinalizedAssignmentItem.getSelectedCellHeader,
        orderById: '',
        data: FinalizedAssignmentItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: 'project_finalizedassignmentselect',
      },
      { label: 'Apollo Id', orderById: 'AsSassieAsgnId', data: FinalizedAssignmentItem.idFunction },
      { label: 'Project', orderById: 'ProjectId', data: FinalizedAssignmentItem.getProjectCellContent },
      { label: 'Survey', orderById: 'SurveyName', data: FinalizedAssignmentItem.getSurveyCellContent, minWidth: 50 },
      { label: 'Location', orderById: 'CuName', data: FinalizedAssignmentItem.getClientUnitCellContent },
      { label: 'Client Fee Total', orderById: 'AsFeeWithSymbol', data: 'AsFeeWithSymbol', minWidth: 80 },
      {
        label: 'Reimb. Total',
        orderById: 'AsReimbursementWithSymbol',
        data: 'AsReimbursementWithSymbol',
        minWidth: 80,
      },
      { label: 'FW Office', orderById: 'AsLdvname', data: 'AsLdvname' },
      { label: 'FW Fee', orderById: 'AsFieldworkFeeWithSymbol', data: 'AsFieldworkFeeWithSymbol', minWidth: 80 },
      { label: 'Eval Fee Total', orderById: 'FeeTotal', data: 'EvalFeeTotal', minWidth: 80 },
      { label: 'Eval Reimb. Total', orderById: 'ReimbTotal', data: 'EvalReimbursementTotal', minWidth: 80 },
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname' },
      { label: 'Status', orderById: 'LgsDesc', data: 'LgsDesc', minWidth: 70 },
      {
        label: 'Completed On',
        orderById: 'AsEvaluatorCompletedDateFormatted',
        data: 'AsEvaluatorCompletedDateFormatted',
        minWidth: 90,
      },
      { label: 'Country', orderById: 'CuCountry', data: 'CuCountry', minWidth: 55 },
    ];
  }
  static selectedStatus() {
    return false;
  }

  static getClientUnitCellContent(item) {
    return (
      <LongText
        text={item.CuName}
        maxLength={20}
      />
    );
  }

  static getProjectCellContent(item) {
    return (
      <LongText
        text={`${item.AsCfid} - ${item.AsCfname}`}
        maxLength={12}
      />
    );
  }

  // Written as the Survey filter lists the survey, with its Apollo id; the id alone when Bravo has no such survey.
  static getSurveyCellContent(item) {
    return (
      <LongText
        text={stringHelper.toNameWithBracketedId(item.SurveyName, item.AsSassieSurveyId)}
        maxLength={30}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={FinalizedAssignmentItem.selectedStatus()}
          onChange={(e) => {
            FinalizedAssignmentItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            FinalizedAssignmentItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
